function objectValue(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function textValue(value) {
  return String(value || '').trim();
}

function applyToken(next, key, value) {
  const text = textValue(value);
  if (text) {
    next[key] = text;
  }
}

function applyTokenOverrides(next, overrides = {}) {
  Object.entries(objectValue(overrides)).forEach(([key, value]) => {
    applyToken(next, key, value);
  });
}

function applySemanticColors(next, colors = {}) {
  const source = objectValue(colors);
  const primary = textValue(source.primary || source.accent);
  const surface = textValue(source.surface);
  const background = textValue(source.background || source.appBg || surface);

  applyToken(next, 'appBg', background);
  applyToken(next, 'panelBg', background);
  applyToken(next, 'surfaceBg', surface);
  applyToken(next, 'composerBoxBg', surface);
  applyToken(next, 'scenarioBg', surface);
  applyToken(next, 'scenarioCardBg', surface);
  applyToken(next, 'sidebarBg', source.sidebar);
  applyToken(next, 'bubbleUserBg', primary);
  applyToken(next, 'surfaceBorderActive', primary);
  applyToken(next, 'scenarioCardBorderActive', primary);
}

export function resolveThemeTokens({ baseTokens, branding, appearance } = {}) {
  const source = objectValue(branding);
  const next = {
    ...objectValue(baseTokens),
  };

  applySemanticColors(next, source.colors);
  applyTokenOverrides(next, source.themeTokens);
  const palette = objectValue(objectValue(source.appearances)[appearance]);
  applySemanticColors(next, palette.colors);
  applyTokenOverrides(next, palette.themeTokens);
  return next;
}
